import React from "react";
import Table from "../../Common/Table";
import TableFields from "../../../constants/FeatureToggle/TableFields.json";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import moment from "moment";
import { Pill } from "../../../constants/assets/containers";

const FeatureToggleList = (props) => {
  const { handleClick, featureToggleList, handleToggleUpdate } = props;
  console.log("featureToggleList --->", featureToggleList);
  const allActions = MenuActionsMappings[MenuNames.FEATURE_TOGGLE];

  const getFieldValue = (featureToggle, key) => {
    switch (key) {
      case "enabled":
        return (
          <div className="flex items-center">
            <Pill className="mr-6" isFalse={!featureToggle[key]}>
              {featureToggle[key] ? "Yes" : "No"}
            </Pill>
            <Permission
              requiredPerms={[allActions.UPDATE]}
              notAllowedText="No Actions Permitted"
            >
              <span
                onClick={() =>{
                    if (process.env.REACT_APP_ENV === "production") {
                      const submitConfirmationModal = window.confirm("[PRODUCTION ENV] are you sure you want change feature toggle status?");
                      if(!submitConfirmationModal) return;
                    }
                    handleToggleUpdate(featureToggle, featureToggle[key])
                  }
                }
                className={"edit-options cursor-pointer"}
              >
                {featureToggle[key] ? "Disable" : "Enable"}
              </span>
            </Permission>
          </div>
        );
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.DETAIL, allActions.UPDATE]}
            notAllowedText="No Actions Permitted"
          >
            <span
              onClick={() => handleClick("Edit", featureToggle.id)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "createdAt":
      case "updatedAt":
        return featureToggle[key]
          ? moment(featureToggle[key]).format("MMMM DD,YYYY hh:mm")
          : "-";
      default:
        return featureToggle[key];
    }
  };

  return (
    <Permission requiredPerms={[allActions.LIST]}>
      <Table
        list={featureToggleList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </Permission>
  );
};

export default FeatureToggleList;
